<template>
  <div class="easy_form_wrap">
    <vxe-modal
      v-model="easyformConfig.show"
      @hide="hideModel"
      @show="showHandle"
      :fullscreen="false"
      :width="easyformConfig.width"
      :height="easyformConfig.height"
      :min-height="160"
      show-footer
      :transfer="true"
      :destroy-on-close="true"
    >
      <template #title>
        <span>{{easyformConfig.title}}</span>
      </template>
      <template #default>
        <div class="easy_form_inner_wrap">
          <div
            class="easy_form_inner_wrap_item"
            v-for="(item, index) in easyformConfig.config"
            :key="index"
          >
            <div class="lab" :class="{'required':item.required}">{{item.label}}</div>
            <div class="con">
              <el-input
                size="mini"
                v-if="item.kjlx=='input'"
                v-model="item.value"
                :placeholder="'请输入'+item.label"
                :disabled="item.readonly"
                @change="item.changeFunction?item.changeFunction(item,easyformConfig.config):null"
              ></el-input>
              <el-input
                size="mini"
                v-if="item.kjlx=='number'"
                type="number"
                v-model="item.value"
                :placeholder="'请输入'+item.label"
                :disabled="item.readonly"
                @change="item.changeFunction?item.changeFunction(item,easyformConfig.config):null"
              ></el-input>
              <el-input
                size="mini"
                v-if="item.kjlx=='textarea'"
                type="textarea"
                v-model="item.value"
                :placeholder="'请输入'+item.label"
                :disabled="item.readonly"
                @change="item.changeFunction?item.changeFunction(item,easyformConfig.config):null"
              ></el-input>
              <el-date-picker
                v-if="item.kjlx=='date'"
                v-model="item.value"
                type="date"
                value-format="yyyy-MM-dd"
                size="mini"
                class="my_form"
                :disabled="item.readonly"
                placeholder="选择日期"
                @change="item.changeFunction?item.changeFunction(item,easyformConfig.config):null"
              ></el-date-picker>
              <el-date-picker
                v-if="item.kjlx=='datetime'"
                v-model="item.value"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                size="mini"
                class="my_form"
                :disabled="item.readonly"
                placeholder="选择日期"
                @change="item.changeFunction?item.changeFunction(item,easyformConfig.config):null"
              ></el-date-picker>
              <el-radio-group
                :disabled="item.readonly"
                v-model="item.value"
                v-if="item.kjlx=='radio'"
                @change="item.changeFunction?item.changeFunction(item,easyformConfig.config):null"
              >
                <el-radio
                  :label="item2.value"
                  v-for="(item2, index2) in formatList(item)"
                  :key="index2"
                >{{item2.label}}</el-radio>
              </el-radio-group>
              <el-select
                size="mini"
                v-if="item.kjlx=='select'"
                v-model="item.value"
                :placeholder="'请选择'+item.label"
                class="my_form"
                :disabled="item.readonly"
                @change="item.changeFunction?item.changeFunction(item,easyformConfig.config):null"
              >
                <el-option
                  v-for="(item2, index2) in formatList(item)"
                  :key="index2"
                  :value="item2.value"
                  :label="item2.label"
                ></el-option>
              </el-select>
              <el-button v-if="item.buttonFunction" type="primary" size="mini" icon="el-icon-more"></el-button>
            </div>
          </div>
        </div>
      </template>
      <template #footer>
        <vxe-button size="mini" @click="easyformConfig.show=false">取消</vxe-button>
        <vxe-button size="mini" status="primary" @click="easyformConfig.confirm(getData(),easyformConfig)">确认</vxe-button>
      </template>
    </vxe-modal>
  </div>
</template>

<script>
export default {
  name: "CommonEasyForm",
  methods: {
    hideModel() {},
    showHandle() {},
    getData(){
      var c=this.easyformConfig.config
      var d={}
      for(var i in c){
        d[i]=c[i].value
      }
      return d
    },
    formatList(item) {
      if (item.formatList && window[item.formatList]) {
        if (window[item.formatList](item) instanceof Array) {
          return window[item.formatList](item);
        } else {
          return [];
        }
      } else {
        return item.list;
      }
    }
  },
  props: {
    easyformConfig: {}
  },
  data() {
    return {};
  },
  created() {}
};
</script>

<style lang="scss" scoped>
.easy_form_inner_wrap {
    height: 100%;
    background: #ffffff;
    overflow: auto;
    padding: 5px 10px 15px;
    .easy_form_inner_wrap_item{
        .my_form {
            width: 100% !important;
        }
        .lab {
            font-weight: bold;
            color: #409eff;
        }
    }
    .easy_form_inner_wrap_item~.easy_form_inner_wrap_item{
        margin-top: 20px;
    }
}
</style>
